import { Box, Typography, TextField, styled } from "@mui/material";
import React from "react";
import dayjs from "dayjs";
import weekOfYear from "dayjs/plugin/weekOfYear";
import customParseFormat from "dayjs/plugin/customParseFormat";
import localizedFormat from "dayjs/plugin/localizedFormat";
import isBetween from "dayjs/plugin/isBetween";
import advancedFormat from "dayjs/plugin/advancedFormat";

dayjs.extend(weekOfYear);
dayjs.extend(customParseFormat);
dayjs.extend(localizedFormat);
dayjs.extend(isBetween);
dayjs.extend(advancedFormat);

const InputDate = ({
  title,
  name,
  purchaseDate,
  lastServiceDate,
  handleChange,
  value,
  errors,
  disable,
  noMaxDate
}) => {
  const today = dayjs().format("YYYY-MM-DD");
  const minDate =
    name === "lastServiceDate" ? dayjs(purchaseDate).format("YYYY-MM-DD") : "";

  return (
    <Box>
      <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
        {title}
      </Typography>
      <input
        type="date"
        name={name}
        value={value ? dayjs(value).format("YYYY-MM-DD") : ""} // Format to YYYY-MM-DD
        onChange={(e) => {
          const newValue = e.target.value;
           handleChange({ name, value: newValue });
        }}
        disabled={disable}
        max={noMaxDate ? undefined : today}    
         min={minDate}
         onFocus={(e) => {
          e.target.style.border = "2px solid #418eda"; // Blue border
          e.target.style.paddingLeft = "9px"; // Reduce padding
          e.target.style.paddingRight = "9px"; // Reduce padding

        }}
        onBlur={(e) => {
          e.target.style.border = "1px solid #B8B8B8"; // Reset border
          e.target.style.padding = "10px"; // Reset padding
        }}style={{
          width: "100%",
          height: "40px",
          padding: "10px",
          backgroundColor: "#FFFFFF",
          border: "1px solid #B8B8B8",
          borderRadius: "5px",
          outline: "none",
          // transition: "border 0.2s ease-in-out",
        }}
      />
      {errors && (
        <Typography variant="body2" color="#D34040">
          {errors}
        </Typography>
      )}
    </Box>
  );
};

export default InputDate;
